import { render, staticRenderFns } from "./AppointmentSearch.vue?vue&type=template&id=f637cba2&"
import script from "./AppointmentSearch.vue?vue&type=script&lang=js&"
export * from "./AppointmentSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports